import React, { useEffect, useState, useRef } from 'react';
import ByobCollectionCard from './ByobCollectionCard.jsx';
import ByobTray from './ByobTray.jsx';
import ByobProductCards from './ByobProductCards.jsx';

const BuildYourOwnSetMain = () => {
  const [collectionsData, setCollectionsData] = useState({ collections: [] });
  const [trayData, setTrayData] = useState([]);
  
  // Fetch the data when the component mounts 
  useEffect(() => {
    setCollectionsData(window.collectionData || { collections: [] });
  }, []);

  useEffect(() => {
    console.log("Collection Data" ,collectionsData);
  }, [collectionsData]);  

  useEffect(() => {
    setTrayData([]);
  }, []);

  useEffect(() => {
    console.log("Tray Data" ,trayData);
  }, [trayData]);

  const handleAddToTray = (product) => {
    setTrayData((prevTrayData) => [...prevTrayData, product])
  }

  const handleRemoveFromTray = (index) => {
    setTrayData((prevTrayData) => {
      const newTrayData = [...prevTrayData]
      newTrayData.splice(index, 1)
      return newTrayData
    })
  }

  const [isOverlapping, setIsOverlapping] = useState(false);
  const headerRef = useRef(null);
  const mainRef = useRef(null);

  useEffect(() => {
    const header = document.querySelector('#SiteHeader');
    const main = document.querySelector('#build-your-own-set-main');

    if (header && main) {
      headerRef.current = header;
      mainRef.current = main;
    }

    function checkOverlap() {
      if (headerRef.current && mainRef.current) {
        const rect1 = headerRef.current.getBoundingClientRect();
        const rect2 = mainRef.current.getBoundingClientRect();
    
        setIsOverlapping(!(rect1.right < rect2.left || 
                           rect1.left > rect2.right || 
                           rect1.bottom < rect2.top || 
                           rect1.top > rect2.bottom));
      }
    }

    // Initial check
    checkOverlap();

    // Add scroll event listener
    window.addEventListener('scroll', checkOverlap);

    // Cleanup
    return () => window.removeEventListener('scroll', checkOverlap);
  }, []);

  useEffect(() => {
    console.log('Elements are ' + (isOverlapping ? 'overlapping' : 'not overlapping'));
  }, [isOverlapping]);



  

  // observer.observe(element1);
  // observer.observe(element2);



  return (
    <div id="build-your-own-set-main" className='grid grid-cols-1 md:grid-cols-8 md:px-8 my-5'>
      <div className='col-span-1 md:col-span-7 px-4'>
        <div className=''>
          { collectionsData.collections.length > 0 ? (
            <div>
              { collectionsData.collections.map((collection, index) => (
                <div key={'collection-card-index-' + index} className="mb-8">

                  { collection.products.length > 0 ? (
                    <div className='grid  grid-cols-2 md:grid-cols-12'>
                      {/* Collection Card */}
                      <ByobCollectionCard collection={collection} index={index} />
                      
                      {/* Product Cards */}
                        { collection.products.map((product, index) => (
                        <ByobProductCards product={product} key={'product-card-index-' + index} index={index} handleAddToTray={handleAddToTray}  trayData={trayData}/>
                      ))}
                    </div>
                  ) : (
                    <div>
                      No products found 
                    </div>
                  ) }
                </div>
              ))}
            </div>
          ) : (
            <div>
              No collections found
            </div>
          )}
        </div>
      </div>
      <div className={`col-span-1 order-first md:order-last  ${isOverlapping ? 'fixed top-[58px] z-[9000] md:me-8 md:right-0 md:w-[11%]' : ''}`} id="byob-tray-container">
        <ByobTray trayData={trayData} setTrayData={setTrayData} handleRemoveFromTray={handleRemoveFromTray}  />
      </div>
    </div>
  );
};

export default BuildYourOwnSetMain;